<template>
  <component :is="compId"></component>
</template>
<script>
import systemSet_org_group from './jobRole';
import systemSet_org_roleList from './roleList';

export default {
  components:{
    systemSet_org_group,
    systemSet_org_roleList
  },
  data() {
    return {
      compId:""
    }
  },
  props:{
    viewId:String,
    default:"systemSet_org_group"
  },
  mounted() {
    var me = this;
    if(this.viewId){
      this.compId = this.viewId;
    }else{
      this.compId = "systemSet_org_group";
    }
  },
  methods: {
    changeView(viewId) {
      this.compId = viewId;
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/group.vue